import { APISettings } from "../../config/ApiSettings";
import { EmergencyRegulation } from "../interfaces/EmergencyRegulation";
import { BaseAPI } from "./baseApi";

const baseUrl = new APISettings().getApiURL();

class EmergencyRegulationApi extends BaseAPI {
    public getById: (id: number) => Promise<EmergencyRegulation> = async (id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/EmergencyRegulation/${id}`)).data.output;
    };

    public getByFilingId: (filingId: number) => Promise<EmergencyRegulation[]> = async (filingId: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/EmergencyRegulation/GetByFilingId/${filingId}`)).data.output;
    };

    public createEmergencyRegulation: (emergencyRegulation: EmergencyRegulation) => Promise<EmergencyRegulation> = async (emergencyRegulation: EmergencyRegulation) => {
        return (await BaseAPI.axios.post(`${baseUrl}/EmergencyRegulation`, emergencyRegulation)).data.output;
    }

    public renewEmergencyRegulation: (renewDto: any) => Promise<any> = async (renewDto: any) => {
        return (await BaseAPI.axios.put(`${baseUrl}/EmergencyRegulation/renew`, renewDto)).data.output;
    }
}

export const emergencyRegulationApi = new EmergencyRegulationApi();